import LogLocationForm from './LogLocation';
export default LogLocationForm;
